import { Avatar, Card, CardContent, Stack, Typography } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { InstagramSendIcon } from '../icons/InstagramSendIcon';
import { FacebookReelBookmarkIcon } from '../icons/FacebookReelBookmarkIcon';
import { SocialMediaTypes } from 'types/socialMediaTypes';

const InstagramFeedPreview = (props: SocialMediaTypes) => {
  const { imageUrl } = props;
  return (
    <Card>
      <CardContent style={{ padding: 0 }}>
        {/* Post Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" gap="0.75rem">
            <Avatar style={{ height: '2rem', width: '2rem' }} />
            <Typography variant="h5" fontWeight={500}>
              username
            </Typography>
          </Stack>
          <MoreHorizIcon style={{ height: '1rem', width: '1rem' }} />
        </Stack>

        {/* Post Image */}
        <Stack
          position="relative"
          mt="1rem"
          style={{
            aspectRatio: '1',
          }}
        >
          <img
            src={imageUrl}
            alt="Post content"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Stack>

        {/* Post Actions */}
        <Stack p="0.75rem" gap="0.75rem">
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center" gap="1rem">
              <FavoriteBorderIcon
                style={{
                  height: '1.5rem',
                  width: '1.5rem',
                }}
              />
              <ChatBubbleOutlineIcon
                style={{
                  height: '1.5rem',
                  width: '1.5rem',
                }}
              />
              <InstagramSendIcon
                style={{
                  height: '1.5rem',
                  width: '1.5rem',
                }}
              />
            </Stack>
            <FacebookReelBookmarkIcon
              style={{
                height: '1.5rem',
                width: '1.5rem',
              }}
            />
          </Stack>
          {/* Likes Count */}
          <Typography variant="h6">1200 likes</Typography>

          {/* Caption */}
          <Stack gap="0.25rem">
            <Stack direction="row" gap="0.5rem">
              <Typography variant="h6">post.username</Typography>
              <Typography variant="subtitle2">post.caption</Typography>
            </Stack>
            <Typography variant="subtitle2">View all 80 comments</Typography>
            <Typography variant="subtitle2">8 hours ago</Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default InstagramFeedPreview;
